/**
 * 회차 상태를 화면에 옮기는 말과 색.
 *
 * 매트릭스와 회차 기록 화면이 같은 회차를 서로 다르게 부르면, 칸을 눌러 들어간
 * 사람이 같은 것을 보고 있는지 알 수 없다. 한 곳에 둔다.
 */

/**
 * Visual language for the five slot states.
 *
 * Each carries a symbol as well as a colour: at 28px on a phone, colour alone
 * is not reliably distinguishable, and it excludes colour-blind viewers.
 */
export const STATE = {
    ON_TIME: { symbol: '✓', color: '#059669', bg: '#d1fae5', text: '정시 완료' },
    // 지연과 조기는 기호와 색을 공유한다. 시스템이 둘을 똑같이 취급하기
    // 때문이다 -- 정시율에서 빠지고 이행률에 들어간다. 기호는 '이 칸이 어떤
    // 상태인가'를 말하고, 늦은 것인지 이른 것인지는 그 상태의 사유라서 글자가
    // 맡는다. bucketText 는 둘을 한데 세는 범례와 집계에서 쓴다.
    LATE: {
        symbol: '⏱', color: '#b45309', bg: '#fef3c7',
        text: '지연 완료', bucketText: '지연·조기 완료',
    },
    EARLY: { symbol: '⏱', color: '#b45309', bg: '#fef3c7', text: '조기 완료' },
    MISSED: { symbol: '✕', color: '#dc2626', bg: '#fee2e2', text: '미이행' },
    PENDING: { symbol: '○', color: '#6b7280', bg: '#f3f4f6', text: '대기' },
    EMPTY: { symbol: '·', color: '#d1d5db', bg: 'transparent', text: '' },
};

/** 저장된 status 는 LATE 하나지만, 화면에서는 조기와 지연을 갈라 보여준다. */
export const stateOf = (slot) =>
    (slot?.timing === 'EARLY' ? STATE.EARLY : STATE[slot?.status]) || STATE.PENDING;

export const fmtTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    const h = d.getHours();
    const suffix = h < 12 ? '오전' : '오후';
    const hour12 = h % 12 === 0 ? 12 : h % 12;
    return `${suffix} ${hour12}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const fmtLateness = (minutes) => {
    if (!minutes) return null;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0) return `${h}시간 ${m > 0 ? `${m}분 ` : ''}지연`;
    return `${m}분 지연`;
};
